import { render, staticRenderFns } from "./TecladoNumerico.vue?vue&type=template&id=9f6817ae&scoped=true&lang=true&"
import script from "./TecladoNumerico.vue?vue&type=script&lang=js&"
export * from "./TecladoNumerico.vue?vue&type=script&lang=js&"
import style0 from "./TecladoNumerico.vue?vue&type=style&index=0&id=9f6817ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f6817ae",
  null
  
)

export default component.exports